import { cloned, toVarName, slugify } from '@/helpers'
import { RecordDef, is, isVisibleType } from '@/models'

export function mapControl(prefix, field) {
  /**
   * Maps a given Field
   * @returns: a mapped field or Null
   * 
   * Only fields withs values can be mapped.
   */
  if (!isVisibleType(field.type)) 
    return null;

  const subtype = field.options.subtype;
  const entry = field.type + '.'+(subtype || '');
  let mapped = null;
  try {
    mapped = cloned(Mapper[entry](field));
  }
  catch(err) {
    console.log("mapControl", entry, err)
  }
  if (mapped === null)
    return null;

  if (!mapped) {
    console.log(entry, field)
    return null;
  }

  mapped.key = prefix+'.'+field.property;
  mapped.label = field.label;
  mapped.name = slugify(field.label || '');
  mapped.group = 'cols';  

  return mapped
}


/**
 * Mappers for Schema and Connector for all Field types
 */
const Mapper = {
  'TextField.string': toText(),
  'TextField.title': toText(),
  'TextField.notes': toText(),
  'NumberField.int': toInteger(),
  'NumberField.decimal': toNumeric(),
  'NumberField.phone': toVarchar(24),
  'DateField.date': toDate(),
  'DateField.datestr': toDate(),
  'TimeField.time': toTime(),
  'CheckField.default': toVarchar(6),
  'OptionField.options': toOption(128),
  'OptionField.select': toOption(128),
  'ItemField.': toItem(256),
  'QRCodeField.': toText(),
  'CalculatedField.': toNumeric(),
  'GpsField.': toVarchar(128),
  'LocalStockPlugin.': toNumeric(),
  'LocalTicketPlugin.': toItem(256),
  'EmailAlertPlugin.': toText(),
  'RemoteCallPlugin.': toText(),
  ///
  'PhotosField.': toNull(),
  'SignatureField.': toNull(),
  'AttachsField.': toNull(),
  'GraphField.': toNull(),
}

function toVarchar(size) {
  return function() {
    return ({ 
      type: "text", 
      sqltype: `varchar(${size})`
    }) ;
  }
}

function toText() {
  return function() {
    return ({ 
      type: "text", 
      sqltype: "text"
    }) ;
  }
}

function toOption(size) {
  return function(field) { 
    return ({ 
      type: "text", 
      sqltype: `varchar(${size})`,
      extra: { map: field.domain }
    })
  } ;
}

function toItem(size) {
  return function() {
    return ({ 
      type: "item", 
      sqltype: `varchar(${size})`,
      extra: { format: '%(descr)s' }
    })
 } ;
}

function toInteger() {
  return function() {
    return ({ 
      type: "integer", 
      sqltype: "integer"
    }) ;
  }
}

function toNumeric() {
  return function() {
    return ({ 
      type: "float", 
      sqltype: "numeric"
    }) ;
  }
}

function toDate() {
  return function() {
    return ({ 
      type: "date", 
      sqltype: "date",
      default: "2000-01-01",
      extra: { format: "%Y-%m-%d" }
    }) ;
  }
}

function toTime() {
  return function() {
    return ({ 
      type: "time", 
      sqltype: "time",
      default: "00:00:00",
      extra: { format: "%H:%M:%S" }
    }) ;
  }
}

function toNull() {
  return function() {
    return null;
  }
}
